<template>
  <!-- 导入订单数据弹窗 -->
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.SelectImportContent')"
    width="400px"
    :close-on-click-modal="false"
  >
    <div>
      <div style="display: flex; flex-direction: row;align-items: center;margin: 15px 0;">
        <span>{{ $t('SeaExport.ImportBusinessNo') }}：</span><el-input v-model="jobNo" no="jobNo" style="width: 210px;" />
        <el-button no="filterJob" type="primary" style="margin:0 10px;" @click="findJob()">...</el-button>
      </div>
      <fieldset>
        <legend>{{ $t('Message.ImportContent') }}</legend>
        <div style="display: flex;flex-direction: column;padding-left: 30px;">
          <el-checkbox v-model="defaultImportOrder.basicInfo" :disabled="true">{{ $t('SeaExport.BasicInfo') }}</el-checkbox>
          <el-checkbox v-show="lob === 'SE'" v-model="defaultImportOrder.booking">{{ $t('SeaExport.Booking') }}</el-checkbox>
          <el-checkbox v-show="lob === 'SE'" v-model="defaultImportOrder.prePlanBooking">{{ $t('SeaExport.prePlanBooking') }}</el-checkbox>
          <el-checkbox v-show="lob === 'SE' || lob === 'AE'" v-model="defaultImportOrder.mbl">{{ lob === 'AE' ? 'MAWB' : 'MBL' }}</el-checkbox>
          <el-checkbox v-show="lob === 'SE' || lob === 'AE'" v-model="defaultImportOrder.hbl">{{ lob === 'AE' ? 'HAWB' : 'HBL' }}</el-checkbox>
          <el-checkbox v-model="defaultImportOrder.charge">{{ $t('SeaExport.Charge') }}</el-checkbox>
        </div>
      </fieldset>
      <div style="display: flex; flex-direction: row;align-items: center">
        <el-radio-group v-model="defaultImportOrder.isOverwritesDifference" style="margin-top: 15px;margin-bottom: 10px;">
          <el-radio :label="true"><span style="font-size: 13px">{{ $t('Message.DifferenceOverwritesTheOriginalValue') }}</span></el-radio>
          <el-radio :label="false"><span style="font-size: 13px">{{ $t('Message.DifferenceRetainsTheOriginalValue') }}</span></el-radio>
        </el-radio-group>
      </div>
      <div style="display: flex; flex-direction: row;align-items: center">
        <el-checkbox v-model="rememberChoose" style="margin-top: 10px;margin-bottom: 5px;">
          <span style="font-size: 12px">{{ $t('Message.RememberToChoose') }}</span>
        </el-checkbox>
      </div>
    </div>
    <span slot="footer">
      <el-button no="confirm" type="primary" @click="enterHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
    <query-job-dialog
      :visible.sync="queryJobDialog.visible"
      :lob="lob"
      :job="job"
      @callback="row=>{callbackSelectedJob(row)}"
    />
  </el-dialog>
</template>

<script>

import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import queryJobDialog from '@/components/Cargo/Job/queryJobDialog'
import { queryJobNoLinkFunc } from '@/api/booking/job'

export default {
  name: 'ImportOrderDialog',
  components: { queryJobDialog },
  props: {
    visible: { type: Boolean, required: true },
    lob: { type: String, default: '' },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      rememberChoose: true, // 记住选择
      jobNo: '', // 导入业务编号
      queryJobDialog: {
        visible: false
      },
      defaultImportOrder: {
        basicInfo: true,
        booking: true,
        prePlanBooking: true,
        mbl: true,
        hbl: true,
        charge: true,
        isOverwritesDifference: false
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.rememberChoose = true
        this.jobNo = ''
        this.init()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.init()
    }
  },
  methods: {
    init() {
      const defaultImportOrder = LocalStorageUtilsNew.getConfiguration('defaultImportOrder' + this.lob)
      if (defaultImportOrder) {
        if (defaultImportOrder.hasOwnProperty('booking')) {
          this.defaultImportOrder.booking = defaultImportOrder.booking
        }
        if (defaultImportOrder.hasOwnProperty('prePlanBooking')) {
          this.defaultImportOrder.prePlanBooking = defaultImportOrder.prePlanBooking
        }
        if (defaultImportOrder.hasOwnProperty('mbl')) {
          this.defaultImportOrder.mbl = defaultImportOrder.mbl
        }
        if (defaultImportOrder.hasOwnProperty('hbl')) {
          this.defaultImportOrder.hbl = defaultImportOrder.hbl
        }
        if (defaultImportOrder.hasOwnProperty('charge')) {
          this.defaultImportOrder.charge = defaultImportOrder.charge
        }
        if (defaultImportOrder.hasOwnProperty('isOverwritesDifference')) {
          this.defaultImportOrder.isOverwritesDifference = defaultImportOrder.isOverwritesDifference
        }
      }
    },
    async enterHandler() {
      if (!this.jobNo) {
        this.$message.info(this.$t('CargoMsg.Cargo_InputBusinessNumber'))
        return
      }
      if (this.jobNo === this.job.jobNo) {
        this.$message.warning(this.$t('Message.TheIDOfTheImportedServiceMustBeDifferentFromThatOfTheImportedService'))
        return
      }
      const job = await queryJobNoLinkFunc({ jobNo: this.jobNo }).then(res => res.data)
      if (!job || !job.uuid) {
        this.$message.warning(this.$t('Message.TheImportedServiceNumberDoesNotExistProcedure'))
        return
      }
      if (this.rememberChoose) {
        const defaultImportOrder = {}
        defaultImportOrder.booking = this.defaultImportOrder.booking
        defaultImportOrder.prePlanBooking = this.defaultImportOrder.prePlanBooking
        defaultImportOrder.mbl = this.defaultImportOrder.mbl
        defaultImportOrder.hbl = this.defaultImportOrder.hbl
        defaultImportOrder.charge = this.defaultImportOrder.charge
        defaultImportOrder.isOverwritesDifference = this.defaultImportOrder.isOverwritesDifference
        // 存本地缓存
        LocalStorageUtilsNew.setConfiguration('defaultImportOrder' + this.lob, defaultImportOrder)
      } else {
        LocalStorageUtilsNew.removeConfiguration('defaultImportOrder' + this.lob)
      }
      const data = { job: job, selectedTabs: this.defaultImportOrder }
      this.confirmCallBack(data)
      this.close()
    },
    confirmCallBack(job) {
      this.$emit('confirmCallBack', job)
    },
    findJob() {
      this.queryJobDialog.visible = true
    },
    callbackSelectedJob(row) {
      if (!row || !row.jobNo) return
      this.jobNo = row.jobNo
    },
    close() {
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
